import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <main className="relative overflow-hidden pb-24 pt-16 lg:pt-24">
      <div className="pointer-events-none absolute -top-24 right-1/4 h-[24rem] w-[24rem] rounded-full bg-gold/10 blur-[110px]" />

      <div className="relative z-10 mx-auto w-full max-w-3xl px-4 sm:px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="mb-8 flex w-fit items-center gap-2 font-mono text-[11px] tracking-[0.2em] text-slate-500 transition-colors duration-300 hover:text-gold"
          >
            <ArrowLeft className="h-3.5 w-3.5" /> BACK TO SITE
          </Link>

          <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-gold">VPS</p>
          <h1 data-testid="privacy-title" className="font-serif text-3xl font-bold tracking-tight text-navy sm:text-5xl">
            Privacy Policy
          </h1>

          <div className="mt-10 rounded-3xl border border-slate-200 bg-white p-8 shadow-xl sm:p-12">
            <p data-testid="privacy-statement" className="text-base leading-relaxed text-slate-600">
              Vanguard Prep School Limited collects the information in this
              form to respond to your interest in enrolling your child, to
              contact you about enrolment and information events and, if you
              agree, to send you news about the School. Your information will
              be held securely by Vanguard Prep School Limited and used only by
              our staff involved in enrolment and our service providers,
              including Advance Training Group Limited, which provides
              administrative services to the School. We will not share it with
              anyone else without your consent unless the law requires us to.
              Providing this information is voluntary, but without it we may
              not be able to respond to your enquiry. You can ask to see or
              correct your information at any time by contacting our Privacy
              Officer at{" "}
              <a
                href="mailto:privacy@vanguardprep.school.nz"
                className="text-gold-hover underline underline-offset-2 transition-colors duration-300 hover:text-gold"
              >
                privacy@vanguardprep.school.nz
              </a>
              .
            </p>
          </div>
        </motion.div>
      </div>
    </main>
  );
}
